import { api } from "@/APIRequests";
import type { PatientDiagnosis } from "@/core/types";

export async function getPatientDiagnosis(patientId: string): Promise<PatientDiagnosis> {
  return api.sharedTyped.get_patient_diagnosis({
    params: { showLoader: false },
    patientId,
  });
}
